if (!customElements.get('x-modal')) {
  customElements.define(
    'x-modal',
    class XModal extends HTMLElement {
      constructor() {
        super();
        const { slotName, cancelClass, confirmClass, modalName } = this.dataset;
        this.attachShadow({ mode: 'open' });
        this.open = this.hasAttribute('open');
        this.shadowRoot.innerHTML = `
          <style>
            :host {
              display: ${this.open ? 'block' : 'none'};
            }
            .x-modal {
              position: absolute;
              left: 0;
              top: 0;
              z-index: 1002;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .x-modal-mask {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1001;
              background: rgba(0, 0, 0, 0.4);
              -webkit-backdrop-filter: blur(5px);
              backdrop-filter: blur(5px);
            }
            .x-modal-content {
              position: fixed;
              z-index: 1003;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          </style>
          <div class="x-modal">
            <div class="x-modal-mask"></div>
            <div class="x-modal-content">
              <slot name="${slotName}"></slot>
            </div>
          </div>
          `;
        this.slotName = slotName;
        this.destoryOnClose = this.hasAttribute('destory-on-close');
        this.clickMaskClose = this.hasAttribute('click-mask-close');
        this.cancelClass = cancelClass;
        this.confirmClass = confirmClass;
        this.modalName = modalName;
      }
      toggleModal(visible) {
        const status = visible ? 'block' : 'none';
        this.style.display = status;
      }
      connectedCallback() {
        if (this.parentNode !== document.body) {
          document.body.appendChild(this);
          return;
        }
        const $modal = this.shadowRoot.querySelector('.x-modal');
        const $mask = $modal.querySelector('.x-modal-mask');
        const slotSelector = `[slot="${this.slotName}"]`;

        if (this.clickMaskClose) {
          $mask.addEventListener('click', () => {
            this.toggleModal(false);
          });
        }

        $modal.addEventListener('click', (e) => {
          const $target = e.target;
          // stop event bubbling, prevent some effects
          e.stopPropagation();
          // on close btn submit
          // close modal and reset form by subscriber
          if (
            $target.classList.contains(this.cancelClass) ||
            $target.closest('button')?.classList.contains(this.cancelClass)
          ) {
            this.toggleModal(false);
            publish(PUB_SUB_EVENTS.xModalClose);
          }

          // on confirm btn submit
          // publish close method to subscriber
          if ($target.classList.contains(this.confirmClass)) {
            publish(PUB_SUB_EVENTS.xModalConfirm, {
              closeMethod: () => this.toggleModal(false),
              modalName: this.modalName,
              targetNode: $target,
            });
          }
        });

        this.contentTpl = this.querySelector(slotSelector);
        subscribe(PUB_SUB_EVENTS.xModalOpen, (data) => {
          if (data.modalName !== this.modalName) return;
          if (this.destoryOnClose) {
            const template = this.contentTpl.cloneNode(true);
            const $content = this.querySelector(slotSelector);
            $content.remove();
            this.append(template);
          }
          if (typeof data.contentRender === 'function') {
            data.contentRender(this.querySelector(slotSelector));
          }
          this.toggleModal(true);
        });
      }
      disconnectedCallback() {
        this.shadowRoot.querySelector('.x-modal').removeEventListener('click', () => {
          this.remove();
        });
      }
    }
  );
}
